var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('activation-tasks-summary-provider',{staticStyle:{"height":"100%"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var briefs = ref.briefs;
var close = ref.close;
return [_c('activation-tasks-summary-view',{attrs:{"briefs":briefs},on:{"close":close}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }